




























































import { Vue, Component, Prop } from 'vue-property-decorator';
import Modal from '@/components/Modal.vue';
import Icon from '@/components/Icon.vue';
import idealName from '@/utils/ideal-name';
import { Agent } from '@/store/modules/agent';
import {
    TimelineEntry,
    contradictoryPause,
    timelineIconName,
    timelineIconClass,
    timelineTime,
} from '@/utils/agent/timeline';

// mientras el modal esta abierto se refresca solo; al cerrarlo se corta.
const REFRESH_MS = 15000;

@Component({
    components: {
        Modal,
        Icon,
    },
})
export default class ModalTimeline extends Vue {
    @Prop() readonly agent!: Agent;

    idealName = idealName;

    iconName = timelineIconName;

    iconClass = timelineIconClass;

    formatTime = timelineTime;

    entries: Array<TimelineEntry> = [];

    get visibleEntries(): Array<TimelineEntry> {
        return this.entries.filter((entry) => !contradictoryPause(entry));
    }

    isRefreshing = false;

    refreshHandle: number | null = null;

    beforeDestroy() {
        this.stopRefreshing();
    }

    toogleModal() {
        const modal = this.$refs.modalTimeline as Modal;
        modal.toogleModal();

        // se pide al abrir y no al montar: no vale la pena mantener
        // sincronizada la bitacora de cada agente del panel.
        if (modal.isOpen) {
            this.fetch();
            this.startRefreshing();
        } else {
            this.stopRefreshing();
        }
    }

    startRefreshing() {
        this.stopRefreshing();
        this.refreshHandle = window.setInterval(() => this.fetch(), REFRESH_MS);
    }

    stopRefreshing() {
        if (this.refreshHandle === null) return;

        window.clearInterval(this.refreshHandle);
        this.refreshHandle = null;
    }

    fetch() {
        const { channel } = this.$store.getters.getAgentByName(this.agent.name) || {};

        if (!channel) {
            this.entries = [];
            return;
        }

        this.isRefreshing = true;

        // en el error y el timeout se deja lo que ya estaba: perder la
        // lista por un refresco fallido es peor que mostrarla vieja.
        channel.push('get_agent_timeline', {})
            .receive('ok', (res: { timeline: Array<TimelineEntry> }) => {
                this.entries = res.timeline || [];
                this.isRefreshing = false;
            })
            .receive('error', () => {
                this.isRefreshing = false;
            })
            .receive('timeout', () => {
                this.isRefreshing = false;
            });
    }

    label(entry: TimelineEntry): string {
        switch (entry.k) {
            // entradas escritas antes de unificar la pausa en el estado,
            // siguen vivas en redis hasta 24hs despues del deploy.
            case 'dnd':
                if (entry.v !== 'enabled') return this.$t('agent.timeline.dnd_disabled') as string;
                return entry.s
                    ? this.$t('agent.timeline.dnd_enabled_with_reason', { reason: entry.s }) as string
                    : this.$t('agent.timeline.dnd_enabled') as string;
            case 'tier':
                return this.$t(
                    entry.v === 'ready' ? 'agent.timeline.tier_ready' : 'agent.timeline.tier_standby',
                    { queue: this.queueName(entry.q) },
                ) as string;
            case 'call_in':
                return this.$t(
                    entry.v === 'ended' ? 'agent.timeline.call_in_ended' : 'agent.timeline.call_in',
                    { queue: this.queueName(entry.q), number: entry.n || '' },
                ) as string;
            case 'call_out':
                return this.$t(
                    entry.v === 'ended' ? 'agent.timeline.call_out_ended' : 'agent.timeline.call_out',
                    { number: entry.n || '' },
                ) as string;
            case 'registration':
                return this.$t(
                    entry.v === 'registered'
                        ? 'agent.timeline.registered'
                        : 'agent.timeline.unregistered',
                ) as string;
            default:
                return this.statusEntryLabel(entry);
        }
    }

    // la pausa muestra solo el motivo tal como llega del webphone
    // ("Capacitacion", "Ocupado"), y el disponible sin prefijo.
    statusEntryLabel(entry: TimelineEntry): string {
        if (entry.v === 'unavailable') {
            return entry.s || (this.$t('agent.timeline.dnd_enabled') as string);
        }

        if (entry.v === 'available') {
            return this.statusLabel(entry.v);
        }

        return this.$t('agent.timeline.status', { status: this.statusLabel(entry.v) }) as string;
    }

    // el estado crudo de freeswitch es el substatus, si no lo conocemos
    // se muestra tal cual en vez de esconderlo detras de un generico.
    // los estados estandar llegan en camelCase (LoggedOut, AvailableOnDemand)
    // y las claves i18n estan en snake_case, de ahi la conversion.
    statusLabel(status: string): string {
        const normalized = status
            .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
            .replace(/\s+/g, '_')
            .toLowerCase();
        const key = `agent.status.${normalized}`;
        const translated = this.$t(key) as string;

        return translated === key ? status : translated;
    }

    queueName(queue?: string): string {
        if (!queue) return '';

        return this.$store.getters.queueName(queue) || queue;
    }
}
